import { clinicsData } from "./clinics";

export const headerData = {
  location: {
    label: "Spokój w Głowie - lokalizacje poradni",
    data: clinicsData.map((clinic) => ({
      name: clinic.name,
      hours: clinic.hours,
      address: `${clinic.location.street}, ${clinic.location.city}${
        clinic.location.floor ? `, ${clinic.location.floor} piętro` : ""
      }`,
    })),
  },
  call: {
    label: "Zadzwoń",
    data: [
      {
        name: "Poradnia w Wołominie",
        phones: ["501 775 717", "721 642 466"],
      },
      {
        name: "Poradnia Warszawa Białołęka",
        phones: ["725 396 700"],
      },
    ],
  },
  question: {
    label: "Wyślij zapytanie",
    url: "/kontakt/",
  },
  reservation: {
    label: "Umów wizytę",
    url: "/rezerwacja-wizyt/",
  },
};
